module.exports = __webpack_public_path__ + "img/aaa.a8a9c243.png";